// extracted by mini-css-extract-plugin
export default {"root":"LLPACard_root__QXMLD","numVersions":"LLPACard_numVersions__bFIsm"};